import { useContext } from 'react';
import { EmailContext } from 'contexts/email_context';

const useEmail = () => {
    return useContext(EmailContext);
};

export default useEmail;
